import React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { ArrowRightAlt } from "@material-ui/icons";
import { Container } from "@material-ui/core";

// styles
import useStyles from "./styles";
import HeroImg from "../../images/in-content.svg";

// global data
import { DataInfra, DataApps, AIApps } from "../../context/UserContext";

export default function SubsystemApps() {
  const classes = useStyles();
  let item = {};
  const hash = window.location.hash;

  DataInfra.concat(DataApps).concat(AIApps).forEach(it => {
    it.apps.forEach(tt => {
      if (tt.href === hash) {
        item = {...tt};
      }
    })
  });

  document.title = item.name + " | Venus";

  return (
    <div className={classes.root}>
      <Container maxWidth="lg">
        {/* main */}
        <div className={classes.mainBody}>
          <Grid container>
            <Grid item xs={12} className={classes.subsystemHeader} justifyContent={"flex-end"}>
              <span className={classes.spanTag} onClick={() => window.open(item.doc, "_target")}>Tutorials</span>
              <span className={classes.spanTag} onClick={() => window.open(item.doc, "_target")}>Documentation</span>
            </Grid>
            {/* --- */}
            <Grid item xs={6}>
              <div className={classes.paperLeft}>
                <div>
                  <p className={classes.subsystemName}>
                    {item.name}
                  </p>
                  <p className={classes.logoSlogan}>
                    {item.desc}
                  </p>
                  {!item.state ?
                    <Button
                      endIcon={<ArrowRightAlt />}
                      variant={"contained"}
                      className={classes.buttonInfoToMore}
                      style={{ backgroundColor: item.mainColor, color: "white", cursor: "not-allowed" }}
                    >
                      Get Started
                    </Button>
                    :
                    <Button
                      endIcon={<ArrowRightAlt />}
                      variant={"contained"}
                      className={classes.buttonInfoToMore}
                      style={{ backgroundColor: item.mainColor, color: "white", cursor: "pointer" }}
                      onClick={() => window.open(item.link, "_target")}
                    >
                      Get Started
                    </Button>
                  }
                </div>
              </div>
            </Grid>
            <Grid item xs={6}>
              <Grid container className={classes.pageRight}>
                <img src={HeroImg} width={"150%"} alt="app-hero" />
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
}